import constants from '../constants';

export default (value) => constants.common.PUBLISH_PATH_REGEXP.test(value);
